const DATABASE = "bide-pending-upload";
const STORE = "files";

function openDatabase(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DATABASE, 1);
    request.onupgradeneeded = () =>
      request.result.createObjectStore(STORE, { keyPath: "position" });
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function savePendingFiles(files: File[]) {
  if (!("indexedDB" in window)) return;
  const database = await openDatabase();
  await new Promise<void>((resolve, reject) => {
    const transaction = database.transaction(STORE, "readwrite");
    const store = transaction.objectStore(STORE);
    store.clear();
    files.forEach((file, position) => store.put({ position, file }));
    transaction.oncomplete = () => resolve();
    transaction.onerror = () => reject(transaction.error);
  });
  database.close();
}

export async function takePendingFiles(): Promise<File[]> {
  if (!("indexedDB" in window)) return [];
  const database = await openDatabase();
  const files = await new Promise<File[]>((resolve, reject) => {
    const transaction = database.transaction(STORE, "readwrite");
    const store = transaction.objectStore(STORE);
    const request = store.getAll();
    request.onsuccess = () => {
      const rows = (request.result as { position: number; file: File }[]).sort(
        (a, b) => a.position - b.position,
      );
      store.clear();
      resolve(rows.map((row) => row.file));
    };
    request.onerror = () => reject(request.error);
  });
  database.close();
  return files;
}
